/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-meta-collapsible__item-header').forEach(function(header) {
    header.addEventListener('click', function() {
      header.classList.toggle('active');
      const content = header.nextElementSibling;
      if (content.classList.contains('visible')) {
        content.style.display = 'none';
        content.classList.remove('visible');
      } else {
        content.style.display = 'block';
        content.classList.add('visible');
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
var width = window.outerWidth;
  
if (width <= 999) {
  document.body.addEventListener('click', function (event) {
    if (event.target.matches('.footer__item--links .footer__item-title') || 
        event.target.matches('.footer__item--text .footer__item-title')) {
      
      // Toggle the 'active' class
      event.target.classList.toggle('active');

      // Toggle the visibility of the next sibling with a slide effect
      let ft_content = event.target.nextElementSibling;
      if (ft_content.classList.contains('visible')) {
        ft_content.style.display = 'none';
        ft_content.classList.remove('visible');
      } else {
        ft_content.style.display = 'block';
        ft_content.classList.add('visible');
      }
      // if (ft_content && ft_content.classList.contains('footer__item-content')) {
      //   if (ft_content.style.display === 'block' || ft_content.style.display === '') {
      //     ft_content.style.display = 'none';
      //     ft_content.style.transition = 'height 0.3s ease-out';
      //     ft_content.style.height = '0';
      //   } else {
      //     ft_content.style.display = 'block';
      //     let height = ft_content.scrollHeight + 'px';
      //     ft_content.style.height = height;
      //   }
      // }
    }
  });
}
});


$(document).ready(function () {
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    var loadingImage;
    var pInfScrNode = $('.product-list__inner').find('.next-page_link');	        
    // removeing this condition && pInfScrNode.css('display') != 'none'
    if( $('.product-list__inner').height() - 400 < $(document).scrollTop()) {
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        var pInfScrURL = $('.product-list__inner').find('.next-page_link a').attr("href");
        $('.product-facet__product-list').append('<div class="product-facet-loader"><img src="https://cdn.shopify.com/s/files/1/0443/2642/0638/files/transparent-loader.gif?v=1757591340" class="new-page-loading" /></div>');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            // loadingImage = pInfScrNode.clone().empty().append('');
            // loadingImage.insertAfter(pInfScrNode);
            // pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {    
            // remove loading feedback
            pInfScrNode.next().remove();
            $('.product-list__inner').find('.next-page_link').remove();
            var filteredData = $(data).find(".product-list__inner");
            $('.product-list__inner').append(filteredData.html());
            
            // loadingImage.remove();	              
            $('.product-facet__product-list').find('.new-page-loading').remove();
            pInfScrLoading = false;
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  
          },
          dataType: "html"
        });
      }
    }
  }

  if($('.product-list__inner').length > 0){
    $(window).scroll(function(){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      if( $('.product-list__inner').height() - 400 < $(document).scrollTop()) {
        pInfScrDelay = 20;
      }
    });
  }
});

$(document).ready(function(){
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  $('body').on('click', '.vli_play-video', function () {
    console.log('innnnn');
    const $wrap = $(this).closest('.video-item_wrap');
    const video = $wrap.find('video').get(0); // Get the raw DOM element
    // $wrap.removeClass('paused');
    video.play(); // Now it's the correct way
  });

  $('.video-with-text').each(function(i,e){
    var _this = this;
    let video = $(this).find('video').get(0);
    
    video.addEventListener("play", function () {
      video.setAttribute('controls', true);
      const $wrap = $(this).closest('.video-item_wrap');
      $wrap.removeClass('paused');
    });
  
    video.addEventListener("pause", function () {
      video.removeAttribute('controls');
      const $wrap = $(this).closest('.video-item_wrap');
      $wrap.addClass('paused');
    });
  });

  $('.product_slider_custom').slick({
    slidesToShow: 4,
    arrows: true,
    infinite: false,
    prevArrow: `<button class="slick-prev slick-arrow plsc_arrow" aria-disabled="false" style=""><svg width="20" height="20" viewBox="0 0 19 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 1L2 14.5L18 28" stroke="#6B4A2E" stroke-width="2"/></svg></button>`,
    nextArrow: `<button class="slick-next slick-arrow plsc_arrow" aria-disabled="false" style=""><svg width="20" height="20" viewBox="0 0 19 29" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L17 14.5L1 28" stroke="#6B4A2E" stroke-width="2"/></svg></button>`,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          infinite: true
        }
      }
    ]
  });

  $(".testimonail-secondary_sliderr").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          arrows: false,
          infinite: true
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false,
          infinite: true
        }
      }
    ]
  });

  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  function activecheck(addedcnt,bundle_price,bundle_compare_price){
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      $('.quantity-selector .quantity-selector__button:last-child').attr('disabled','disabled');
      $('.bundle-product-item__cta:not(.added)').attr('disabled','disabled');
      $('.bundle-add_to_cart_button')
      .addClass('readytoadd button--gradient')
      .removeClass('button--outline')
      .removeAttr('disabled');
      $('.bundle-preview_cart-prices').show();
      var bundleamount = parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100;
      $('.bundle-preview_cart-prices .price--highlight').html(formatMoney(bundleamount, currencyFormat));
      $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_price, currencyFormat));
      if(bundle_compare_price > bundle_price){
        var savings = Math.round(((bundle_compare_price - bundle_price) * 100) / bundle_compare_price);
        $('.bundle-preview_cart-prices .save-percent').html(`-${savings}%`);
      }
    }else{
      $('.quantity-selector .quantity-selector__button:last-child').removeAttr('disabled');
      $('.bundle-product-item__cta:not(.added)').removeAttr('disabled');
      $('.bundle-add_to_cart_button').removeClass('readytoadd button--gradient').attr('disabled','disabled').find('.atc_text').text('Add to cart');
      // $('.bundle-preview_cart-prices').hide();
      $('.bundle-preview_cart-prices .price--highlight').html(formatMoney(bundle_price, currencyFormat));
      $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));
      var bundleamount = parseInt($('.bundle-preview_cart-prices').attr('data-off-price')) * 100;
      if(bundle_compare_price > bundle_price){
        var savings = Math.round(((bundle_compare_price - bundle_price) * 100) / bundle_compare_price);
        $('.bundle-preview_cart-prices .save-percent').html(`-${savings}%`);
      }
    }
    
    

    $('#bundle-count-number').html(addedcnt);
    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }
  }

  var addedcnt = 0;
  var bundle_price = 0;
  var bundle_compare_price = 0;
  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));

    var prevval = $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val();
    $(this).closest('.bundle-product-item__cta-wrapper').find('.quantity-selector input').val(parseInt(prevval) + 1);
    console.log(bundle_compare_price)
    activecheck(addedcnt,bundle_price,bundle_compare_price);    

    // $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--gradient');
    // $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall">x</span>`);

    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item hasicon" 
    data-vid="${$(this).closest('.product-item').attr('data-variant-id')}"
    data-pid="${$(this).closest('.product-item').attr('data-product-id')}"
    data-price="${$(this).closest('.product-item').attr('data-product-price')}"
    data-compare_price="${parseInt($(this).closest('.product-item').attr('data-product-compareprice'))}"
    data-qty="1"
    >
      <div class="bundle-preview_cart-item-wrapper">
        <img src="${featuredimage}" loading="lazy" width="60" height="60" alt="">
        <div class="bundle-preview_car-item-remove text--xsmall"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="10" height="10" x="0" y="0" viewBox="0 0 329.269 329" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M194.8 164.77 323.013 36.555c8.343-8.34 8.343-21.825 0-30.164-8.34-8.34-21.825-8.34-30.164 0L164.633 134.605 36.422 6.391c-8.344-8.34-21.824-8.34-30.164 0-8.344 8.34-8.344 21.824 0 30.164l128.21 128.215L6.259 292.984c-8.344 8.34-8.344 21.825 0 30.164a21.266 21.266 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25l128.21-128.214 128.216 128.214a21.273 21.273 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25 8.343-8.34 8.343-21.824 0-30.164zm0 0" fill="#fff" opacity="1" data-original="#000000" class=""></path></g></svg></div>
        <div class="bundle-preview_car-item-qty text--xsmall">x1</div>
      </div>
    </div>`;
    $('.bundle-preview_cart-items').append(itembox);
    $(this).hide().closest('.bundle-product-item__cta-wrapper').find('.quantity-selector').show();
    // $(this).find('.product-item__cta-text').html(`Added`);
    $(this).siblings('.bunle-product-item-remove').addClass('active');

    
    // var itembox = `<div class="bundle-preview_cart-item-wrapper">
    // <img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall">x</div></div>`; 

    // $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    // $('.bundle-preview_cart-item.hasblank').first().attr('data-vid',$(this).closest('.product-item').attr('data-variant-id')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').attr('data-product-price')).removeClass('hasblank');    
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:last-child', function(e){
    e.preventDefault();
    addedcnt += 1;    
    var prevval = $(this).closest('.quantity-selector').find('input').val();
    bundle_compare_price += parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price += parseInt($(this).closest('.product-item').attr('data-product-price'));
    activecheck(addedcnt,bundle_price,bundle_compare_price);
    $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
  });

  $('body').on('click', '.bundle-product-item__cta-wrapper .quantity-selector .quantity-selector__button:first-child', function(e){
    e.preventDefault();    
    addedcnt = addedcnt - 1;
    var prevval = parseInt($(this).closest('.quantity-selector').find('input').val());
    bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
    bundle_price = bundle_price - parseInt($(this).closest('.product-item').attr('data-product-price'));
    activecheck(addedcnt,bundle_price,bundle_compare_price); 
    if(prevval == 0){
      console.log('iffff');
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').remove();  
      $(this).closest('.quantity-selector').hide();
      // $(this).find('.product-item__cta-text').html(`Add To Box`);
      $(this).siblings('.bunle-product-item-remove').removeClass('active');
      $(this).closest('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
    }else{
      $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
    }
  });

  // $('body').on('click', '.bunle-product-item-remove', function(e){
  //   e.preventDefault();    
  //   addedcnt = addedcnt - 1;
  //   var prevval = 0;
  //   bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.product-item').attr('data-product-compareprice'));
  //   bundle_price = bundle_price - (parseInt($(this).closest('.product-item').attr('data-product-price')) * parseInt($('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty')));   
  //   console.log(bundle_price);
  //   activecheck(addedcnt,bundle_price,bundle_compare_price);
  //   console.log('dfdfdfdf',prevval);
  //   if(prevval == 0){
  //     console.log('iffff');
  //     $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').remove(); 
  //     $(this).siblings('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
  //     // $(this).siblings('.bundle-product-item__cta').html(`Add To Box`); 
  //     $(this).removeClass('active');
  //   }else{
  //     $('.bundle-preview_cart-item[data-vid="'+$(this).closest('.product-item').attr('data-variant-id')+'"]').attr('data-qty',prevval).find('.bundle-preview_car-item-qty').html(`x${prevval}`);
  //   }

  //   $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
  //   $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').show();
  //   $(this).closest('.bundle-preview_cart-item').prev().remove();
  //   $(this).closest('.bundle-preview_cart-item').remove();

  //   $(this).siblings('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
  //   // $(`.bundle-preview_cart-item[data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
  //   $(this).remove();
  // });

  $('body').on('click','.bundle-preview_car-item-remove', function(){
    addedcnt = addedcnt - $(this).closest('.bundle-preview_cart-item').attr('data-qty');
    bundle_compare_price = bundle_compare_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-compare_price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));
    bundle_price = bundle_price - (parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price')) * parseInt($(this).closest('.bundle-preview_cart-item').attr('data-qty')));   
    console.log(bundle_price);
    activecheck(addedcnt,bundle_price,bundle_compare_price); 

    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.quantity-selector').hide().find('input').val(0);
    $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').show().removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
    // $(`.product-item[data-variant-id="${$(this).closest('.bundle-preview_cart-item').attr('data-vid')}"]`).find('.bundle-product-item__cta').siblings('.bunle-product-item-remove').removeClass('active');
    $(this).closest('.bundle-preview_cart-item').remove();
  });

  $('body').on('click','.bundle-add_to_cart_button.readytoadd', function(){
    var __this = $(this);
    $(this).attr("aria-busy",true);
    var items = [];
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item:not(.hasblank)').each(function(i,v){
      var val = $(this).attr('data-vid');         
      var qty = $(this).attr('data-qty');         
       items.push({
        quantity: qty,
        id: val
      });   
    });      
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      handleFloCartBtn();
      __this.attr("aria-busy",false);
      // document.getElementById('mini-cart').open = true;
      // onCheckoutClick(this);
      // $(this).removeAttr("aria-busy");
      // $('.bundle-product-item__cta-wrapper').find('.quantity-selector').hide().find('.quantity-selector__input').val(0);
      // $('.bundle-product-item__cta-wrapper').find('.bundle-product-item__cta').show();
      // $('.bundle-preview_cart-items .bundle-preview_cart-item').remove();
      // $('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient');
      // $('.bundle-product-item__cta').html(`Add To Box`); 
      // $('.bunle-product-item-remove').removeClass('active');
      // addedcnt = 0;
      // bundle_price = 0;
      // activecheck(0,bundle_price,bundle_compare_price);     
    }.bind(this));  
    
  });

  $(".mw-testimonial-items-list").slick({
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".mw-images-items-list").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(".mw-featured-collections_item-products-list").slick({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          initialSlide: 1
        }
      }
    ]
  });

  $(".mw-bestseller_item-products-list").slick({
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        }
      }
    ]
  });
  
});

$('.mw-faq-tabs_item').click(function(){
  $('.mw-faq-tabs_item').removeClass('is-selected');
  $('.mw-faq-item').removeClass('is-selected');
  
  $(this).addClass('is-selected');
  
  var activeTab = $(this).attr('data_target');
  $(`.mw-faq-item[data_id="${activeTab}"]`).addClass('is-selected');
  return false;
});
$('.mw-faq-item_title').click(function(){
   $(this).toggleClass('active');
   $(this).next('.mw-faq-item_content').slideToggle();
});

$('.mw-featured-collections_tabs-item_link').click(function(e){
  e.preventDefault();
  $(this).parents('.mw-featured-collections_wrapper').find('.mw-featured-collections_tabs-item_link').removeClass('is-selected');
  $(this).parents('.mw-featured-collections_wrapper').find('.mw-featured-collections_item').removeClass('is-selected');
  
  $(this).addClass('is-selected');
  
  var activeTab = $(this).attr('data_target');
  $(`.mw-featured-collections_item[data_id="${activeTab}"]`).addClass('is-selected');
  $('.mw-featured-collections_item-products-list').slick('refresh');
  return false;
});

$('.product-offers__item-title').click(function(){
  $(this).toggleClass('active'); 
  $(this).next('.product-offers__item-description').toggle();
});

$('.product_meta_accordion-header').click(function(){
  $(this).toggleClass('active'); 
  $(this).next('.product_meta_accordion--content').toggle();
});

$('body').on('click', '.product-item .product_item--variant', function(e) {
  var _this = this;
  e.preventDefault();
  var product_handle = $(this).attr("product_handle");
  console.log('product_handle',product_handle);
  $(_this).parents(".product-item_main").addClass('loading');
  $.ajax({
    type: 'GET',
    url: `/products/${product_handle}?view=product-item`, // replace with your Shopify endpoint
    success: function(data) {
      console.log('data',`${product_handle}?view=product-item`,data);
      $(_this).parents(".product-item_main").removeClass('loading');
      $(_this).parents(".product-item_main").html($(data).html());
    },
    error: function(xhr, status, error) {
      $(_this).parents(".product-item_main").removeClass('loading');
      console.error('AJAX error:', status, error);
    }
  });
});


// infinity loader on collection page
// INFINITE COLLECTION
// var pInfScrLoading = false;
// var pInfScrDelay = 100;

// function pInfScrExecute() {
//   if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
//     var loadingImage;
//     pInfScrNode = $('.product-list__inner').last().find('.more').last();	
//     pInfScrURL = $('.product-list__inner').last().find('.more a').last().attr("href");
//     // removeing this condition && pInfScrNode.css('display') != 'none'
//     if(!pInfScrLoading && pInfScrNode.length > 0) {
//       $('.load_more_pro_svg').html('<img src="https://cdn.shopify.com/s/files/1/0443/2642/0638/files/Rolling.gif?v=1720087400" class="loading" style="display:block; margin:auto;" />'); 
//       $.ajax({
//         type: 'GET',
//         url: pInfScrURL,
//         beforeSend: function() {
//           pInfScrLoading = true;
//           loadingImage = pInfScrNode.clone().empty().append('');
//           loadingImage.insertAfter(pInfScrNode);
//           pInfScrNode.hide();

//           console.log('loading...');
//         },
//         success: function(data) {
//           // remove loading feedback
//           pInfScrNode.next().remove();
//           var filteredData = $(data).find(".product-on-page");
//           filteredData.insertBefore( $("#product-list-foot") );
//           loadingImage.remove();					
//           pInfScrLoading = false;
//           $('.load_more_pro_svg').remove();
//             pInfScrLoading = false;
//             document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
//         },
//         dataType: "html"
//       });
//     }
//   }
// }





  // $('.product-meta-collapsible__item-header').click(function(){
  //   $(this).toggleClass('active');
  //   $(this).next('.product-meta-collapsible__item-content').slideToggle();
  // });
  
// })












